import { NgModule } from '@angular/core';

import { IconsContainerComponent } from './icons-container.component';
import { IconName } from './icons.type';

/**
 *  @deprecated use IconsContainerComponent
 */
@NgModule({
  imports: [IconsContainerComponent],
  exports: [IconsContainerComponent],
})
export class IconsContainerModule {}
export { IconsContainerComponent };
export { IconName } from './icons.type';
export const keyIconMap = <T extends Record<string, IconName>>(v: T): T => v;
